export const APP_VERSION = '0.3.4';

// Visual Sync Constant
// Compensate for Transport scheduling lookahead or UI lag
export const VISUAL_LATENCY_BEATS = 0.0;

// Influence Engine Weights
export const INFLUENCE_WEIGHTS = {
    GLOBAL: 100, // User override
    NARRATIVE: 50, // Section type
    LOCAL: 20, // Genre default
    TRAIT: 10 // Specific strategy
};
